import { instance } from "../../lib/api";
import Constants from "../../utils/CommonConstants";
import { getPTCities } from "../../redux/actions/opportunitySearch.actions";
import { getAgents } from "../../redux/actions/myAccounts.actions";
// import { sortByMapping } from "../../containers/RenewalDashboardOpportunity/RenewalDashboardV2Helpers";

const sortByMapping = {
  opportunityStartDate: "OPPORTUNITY_START_DATE",
  opportunityEndDate: "OPPORTUNITY_END_DATE",
  accountId: "ACCOUNT_ID",
};

export const SET_RENEWAL_DASHBOARD_V2_FILTERS = "SET_RENEWAL_DASHBOARD_V2_FILTERS";
export const RENEWAL_DASHBOARD_V2_LIST = "RENEWAL_DASHBOARD_V2_LIST";
export const SNACKBAR_V2_NOTIFICATION = "SNACKBAR_V2_NOTIFICATION";
export const RENEWAL_DASHBOARD_DRILLDOWN_DATA = "RENEWAL_DASHBOARD_DRILLDOWN_DATA";
export const RENEWAL_DASHBOARD_DETAILS_DATA = "RENEWAL_DASHBOARD_DETAILS_DATA";

const buildRenewalDashboardV2Payload = (
  renewalDashboardV2Filters,
  userInfo,
  includePagination = false
) => {
  const {
    employeeName,
    city,
    sellerType,
    startDate,
    endDate,
    sort,
    order,
    page = 1,
    size = 100,
  } = renewalDashboardV2Filters || {};
  let queryParams = [];
  if (employeeName) {
    const agentIds = employeeName.length
      ? `agentIds=${employeeName.map((curr) => curr.id).join(",")}`
      : `agentIds=${userInfo?.id}`;
    queryParams.push(agentIds);
  }
  if (city && city.length) {
    const cityIds = `cityIds=${city.join(",")}`;
    queryParams.push(cityIds);
  }
  if (startDate || endDate) {
    const dateFrom = startDate
      ? `dateFrom=${startDate.toISOString().substring(0, 10)}`
      : "";
    const dateTo = endDate ? `dateTo=${endDate.toISOString().substring(0, 10)}` : "";
    queryParams.push(dateFrom);
    queryParams.push(dateTo);
  }
  if (sellerType && sellerType.length) {
    const accountTypes = `accountTypes=${sellerType.join(",")}`;
    queryParams.push(accountTypes);
  }
  queryParams.push(`sortBy=${sortByMapping[sort]}`);
  queryParams.push(`sortOrder=${order}`);
  if (includePagination) {
    queryParams.push(`page=${page}`);
    queryParams.push(`size=${size}`);
  }

  return queryParams;
};

export const getRenewalDashboardV2Data = (defaultFilters) => {
  let url = `/sapna/renewal-report/live`;

  return (dispatch, getState) => {
    const { renewalDashboardV2Filters = defaultFilters, userInfo = {} } = getState();
    const queryParams =
      buildRenewalDashboardV2Payload(renewalDashboardV2Filters, userInfo, true) ||
      [];

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        const responseData = response.data;
        const renewalDashboardData = {
          results: responseData?.data || [],
          totalCount: responseData?.totalCount || 0,
        };
        dispatch({
          type: RENEWAL_DASHBOARD_V2_LIST,
          payload: renewalDashboardData,
        });
        return renewalDashboardData;
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
      });
  };
};

export const initRenewalDashboardV2 = (defaultFilters) => {
  return (dispatch) => {
    dispatch(getPTCities());
    return dispatch(getAgents({ companyId: 611174, isFirstChildOnly: true })).then(
      (res) => {
        if (res && res.data && res.data.data) {
          defaultFilters.employeeName = [
            {
              id: res.data.data.userId,
              name: res.data.data.userName,
            },
          ];
        }
        dispatch(setRenewalDashboardV2Filters(defaultFilters));
        return dispatch(getRenewalDashboardV2Data(defaultFilters));
      }
    );
  };
};

export const setRenewalDashboardV2Filters = (filters) => ({
  type: SET_RENEWAL_DASHBOARD_V2_FILTERS,
  payload: filters,
});

export const downloadRenewalDashboardV2 = () => {
  let url = `/sapna/renewal-report/live.csv`;

  return (dispatch, getState) => {
    const { renewalDashboardV2Filters = {}, userInfo } = getState();
    const queryParams =
      buildRenewalDashboardV2Payload(renewalDashboardV2Filters, userInfo) || [];

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return instance({
      url,
      method: "get",
      responseType: "blob",
    })
      .then((response) => {
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `renewal-dashboard-${new Date()
          .toISOString()
          .substring(0, 10)}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        dispatch({
          type: SNACKBAR_V2_NOTIFICATION,
          snackBarType: "success",
          msg: "Download request has been initiated",
        });
      })
      .catch(() => {
        dispatch({
          type: SNACKBAR_V2_NOTIFICATION,
          snackBarType: "error",
          msg: "Download request failed",
        });
      });
  };
};

// Build query params for drill-down dashboard API
const buildDrilldownDashboardPayload = (filters) => {
  const { city, sellerType, startDate, endDate, agentId } = filters || {};
  let queryParams = [];

  if (agentId) {
    queryParams.push(`agentId=${agentId}`);
  }

  if (startDate) {
    queryParams.push(`dateFrom=${startDate.toISOString().substring(0, 10)}`);
  }
  if (endDate) {
    queryParams.push(`dateTo=${endDate.toISOString().substring(0, 10)}`);
  }
  if (city && city.length) {
    const cityIds = city.map((c) => (typeof c === "object" ? c.id : c)).join(",");
    queryParams.push(`cityIds=${cityIds}`);
  }
  if (sellerType && sellerType.length) {
    const accountTypes = sellerType
      .map((type) => (typeof type === "object" ? type.value : type))
      .join(",");
    queryParams.push(`accountTypes=${accountTypes}`);
  }

  return queryParams;
};

// Get drill-down dashboard data
export const getRenewalDashboardDrilldownData = (filters) => {
  let url = `/sapna/renewal-report/dashboard`;

  return (dispatch) => {
    const queryParams = buildDrilldownDashboardPayload(filters) || [];

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        const responseData = response.data;
        dispatch({
          type: RENEWAL_DASHBOARD_DRILLDOWN_DATA,
          payload: responseData?.data || {},
        });
        return responseData?.data || {};
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return [];
      });
  };
};

// Get dashboard details (for metric clicks)
export const getRenewalDashboardDetails = (filters, fieldType) => {
  let url = `/sapna/renewal-report/dashboard/details`;

  return (dispatch) => {
    const queryParams = buildDrilldownDashboardPayload(filters) || [];
    queryParams.push(`fieldType=${fieldType}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return instance({
      url,
      method: "get",
    })
      .then((response) => {
        const responseData = response.data;
        dispatch({
          type: RENEWAL_DASHBOARD_DETAILS_DATA,
          payload: responseData?.data || [],
        });
        return responseData?.data || [];
      })
      .catch((err) => {
        dispatch({
          type: Constants.API_FAIL,
          errMsg: Constants.getErrorMessage(err),
        });
        return [];
      });
  };
};

// Download drill-down dashboard CSV
export const downloadRenewalDashboardDrilldown = (filters) => {
  let url = `/sapna/renewal-report/dashboard.csv`;

  return (dispatch) => {
    const queryParams = buildDrilldownDashboardPayload(filters) || [];

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    return instance({
      url,
      method: "get",
      responseType: "blob",
    })
      .then((response) => {
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `renewal-dashboard-${new Date()
          .toISOString()
          .substring(0, 10)}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        dispatch({
          type: SNACKBAR_V2_NOTIFICATION,
          snackBarType: "success",
          msg: "Download request has been initiated",
        });
      })
      .catch(() => {
        dispatch({
          type: SNACKBAR_V2_NOTIFICATION,
          snackBarType: "error",
          msg: "Download request failed",
        });
      });
  };
};
